import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../shared/Navbar';
import './LandingPage.css';
import { LearningChatMessage, LearningNav, LearningHero, HowItWorks, LearningFooter } from './LearningPageSections';

const exampleMessages: readonly LearningChatMessage[] = [
  {
    role: 'tutor',
    content: 'Let’s solve 3x + 5 = 20. What could we do first to get x on its own?',
  },
  {
    role: 'student',
    content: 'Take away 5?',
  },
  {
    role: 'tutor',
    content: 'Yes — subtract 5 from both sides. That leaves 3x = 15. What’s the next step?',
  },
];

export default function LandingPage() {
  return <div className="lp-root learning-page">
    <Navbar />
    <LearningNav />
    <main>
      <LearningHero lessonTitle="Algebra" messages={exampleMessages} title="Learn anything, one question at a time."
        description="Ready-made courses with structured lessons, brought to life by an AI tutor. Work through tricky topics, ask questions and practise what you’ve learned — all at your own pace.">
        <Link className="tm-button tm-button--primary" to="/subjects">Find a course <span aria-hidden="true">→</span></Link>
        <a className="tm-button tm-button--secondary" href="#how-it-works">How it works</a>
      </LearningHero>
      <HowItWorks />
      <section className="learning-section tm-shell" aria-labelledby="learning-paths-title">
        <div className="learning-section-heading"><h2 id="learning-paths-title">What would you like help with?</h2><p>Explore the course content before choosing a lesson.</p></div>
        <div className="learning-paths">
          <Link className="learning-path" to="/gcse"><h3>GCSE</h3><p>Work through maths, science and English. Revisit class topics and practise for exams.</p><span>Explore GCSE <span aria-hidden="true">→</span></span></Link>
          <Link className="learning-path" to="/11-plus"><h3>11+ preparation</h3><p>Build skills in English, maths and reasoning, with guided teaching and exam practice.</p><span>Explore 11+ <span aria-hidden="true">→</span></span></Link>
          <Link className="learning-path" to="/subjects"><h3>All subjects & levels</h3><p>Find school subjects, university topics and courses for work or personal interests.</p><span>Browse courses <span aria-hidden="true">→</span></span></Link>
        </div>
      </section>
      <section className="learning-section tm-shell"><div className="learning-section-heading"><h2>Built by AI researchers and experienced educators.</h2><p>Our team brings experience designing online and technology-enabled teaching at the University of London and the Open University, UK. TeachMeNow puts conversation and active practice at the centre of learning.</p></div></section>
    </main>
    <LearningFooter />
  </div>;
}
